<template>
    <div class="video-container">
        <div v-for="video in videos" class="video">
          <div v-if="$t(video.title)" :data-video-id="video.id" @click="playVideo(video.id)">
            <img :src="'https://img.youtube.com/vi/' + video.id + '/0.jpg'">
            <div class="video-title" v-html="$t(video.title)"></div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "group-videos",
  props: ["playVideo"],
  data: function() {
    return {
      videos: [
        {
          id: "WFjOqOTKars",
          title: "videos.trailer"
        },
        {
          id: "LfmoHM4DFhY",
          title: "videos.cinema-trailer"
        },
        {
          id: "Ws8RFe2kuVg",
          title: "videos.cd"
        },
        {
          id: "R0UKMvEIjXc",
          title: "videos.was-wird-morgen"
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MainSegments/GroupVideos.vue